import { useCallback, useState, useEffect } from "react";
import { Handle, Position, useReactFlow } from "reactflow";
import FilterListIcon from "@mui/icons-material/FilterList";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Button} from "@mui/material";
import NodeDeleteButton from "./nodeDeleteButton";

const handleStyle = {
  background: "#ADADAD",
  width: "6px",
  height: "6px",
  borderRadius: "60%",
};

function CustomNode3({ id, isConnectable, data}) {
  const { deleteElements,setNodes } = useReactFlow();
  const [nodeId, setNodeId] = useState(id);
  const [state, setState] = useState({
    listButton:"",
    message: "",
    list: [
      {
        id: 1,
        value: "",
      },
    ],
  });

  console.log("state",state);
  

  useEffect(() => {
    if (data !== undefined) {
      setState(data && data.state);
    }
  }, [data]);



  const addListItems = () => {
    const newState = { ...state };
    if (newState.list && newState.list.length > 0) {
      const newList = {
        id: newState.list.length + 1,
        value: "",
      };
      newState.list = [...newState.list, newList];
    } else {
      newState.list = [
        {
          id: 1,
          value: "",
        },
      ];
    }
    setState(newState);
  }
  
  const handleDeleteNode = useCallback(() => {
    deleteElements({ nodes: [{ id }] });
  }, [id, deleteElements]);

  const [isHover, setIsHover] = useState(false);

 
  const deleteList = () => {
    // debugger;
   if(state&&state.list&&state.list.length > 1) {
    const result = state.list.slice(0, -1);
    
    setState((prevState) => ({
      ...prevState,
      list: result
    }));
  
  // console.log(state)
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              state: {
                ...node.data?.state,
                list: result, 
              },
            },
          };
        }
        return node;
      })
    );
  }
  };

  const handleChange = (e, index) => {
    const value = e.target.value;
    const name = e.target.name;
    // console.log(value, name, index);
 
      if (index !== undefined) {
        // debugger;
        setState((prevState) => {
          const newState = { ...prevState };
          if (name === "list") {
            newState.list = prevState.list.map((item, i) => 
              i === index ? { ...item, value: value } : item
            );
          }
          
          // Update nodes with the new state immediately
          setNodes((nodes) =>
            nodes.map((node) => {
              if (node.id === nodeId) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    state: {
                      ...node.data?.state,
                      list: newState.list,
                    },
                  },
                };
              }
              return node;
            })
          );
          
          return newState;
        });
      } else {
        setState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
        setNodes((nodes) =>
          nodes.map((node) => {
            if (node.id === id) {
              if (node.data !== undefined) {
                return {
                  ...node,
                  data: {
                    ...node.data,
                    state: {
                      ...node.data?.state,
                      [name]: value,
                    },
                  },
                };
              } else {
                return {
                  ...node,
                  data: {
                    label: "List node",
                    state: {
                      message: value,
                      list: [
                        {
                          id: 1,
                          value: "",
                        },
                      ],
                    },
                  },
                };
              }
            }
            return node;
          })
        );
      }

  };


  return (
    <div
      className="text-updater-node custome3-size"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="custom_header align-items-center">
        <div
          style={{
            padding: "5px",
           
          }}
    
        >
         <WhatsAppIcon
            style={{
              fontSize: "20px",
              color: "#22D954",
              borderRadius: "5px",
              padding: "2px",
              marginTop: "5px",
              backgroundColor: "#fff",
              boxShadow: "0px 0px 2px 0.5px rgba(0, 0, 0, 0.5)",
            }}
          />
        </div>
        <b className="m-1">List Layout</b>
        {/* delete step (round button + confirmation) */}
        <NodeDeleteButton visible={isHover} onDelete={handleDeleteNode} />
      </div>
      <div className="sub_header">
          <div
            style={{
              marginBottom: "5px",
              paddingBottom: "5px",
              borderBottom: "1px solid #e7e7e7",
              width: "100%",
            }}
            className="d-flex flex-row justify-content-between"
          >
            <span>
              <b>Body</b>
            </span>
           
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <textarea
              type="text"
              name="message"
              value={state ? state.message : ""}
              onChange={(e) => handleChange(e)}
              style={{
                border: "1px solid #e7e7e7",
                borderRadius: "5px",
                padding: "5px",
                outline: "none",
                height: 50,

                resize: "none",
              }}
            />
            </div>
            <span style={{color: "red"}}>{state.message.length>1024? "Body length should be lessthan 1024 char":""}</span>
            </div>
            <div className="sub_header d-flex flex-column">
            <b>List Button</b>
            <div
              style={{
                border: "1px solid #e7e7e7",
                position: "relative",
                borderRadius: "5px",
                fontSize: "9px",
                padding: "3px",
                display: "flex",
              }}
            >
              <input
                type="text"
                name="listButton"
                value={state && state.listButton ? state.listButton : ""}
                style={{
                  border: "none",
                  padding: "5px",
                  width: "100%",
                  outline: "none",
                }}
                onChange={(e) => handleChange(e)}
              />
            </div>
            <span style={{color: "red"}}>{state && state.listButton && state.listButton.length>14? "List length should be lessthan 14 char":""}</span>
          </div>
      <div
        style={{
          paddingBottom: "5px",
          paddingLeft: "5px",
        }}
      >
        Enter List Items
      </div>
      <div className="sub_header">
       {state.list&&state.list.length>0&&state.list.map((item, index) => (
        <div>
            Item {index+1}
       
         <div
         style={{
           border: "1px solid #e7e7e7",
           position: "relative",
           borderRadius: "5px",
           fontSize: "9px",
           padding: "3px",
           display: "flex",
         }}
         className="m-1"
       >
      
         <input
           type="text"
           name="list"
           value={item.value}
           id={index}
           style={{
             border: "none",
             padding: "5px",
             width: "100%",
             outline: "none",
           }}
           onChange={(e) => {handleChange(e, index)}}
         />
         <Handle
           type="source"
           position={Position.Right}
           id={`bsd-${index}-ds`}
           style={{
             display: "flex",
             justifyContent: "flex-end",
           }}
           isConnectable={isConnectable}
         />
       </div>
       <span style={{color: "red"}}>{item.value.length>24? "List length should be lessthan 24 char":""}</span>
       </div>
       ))}
      </div>
      <div className="d-flex flex-row justify-content-between p-1">
                <Button
                    style={{
                     
                      color: state.list.length < 2 ?"none":"red",
                      // backgroundColor: "red",
                      // border: "none",
                      // borderRadius: "5px",
                      // textDecoration: "none",
                      // cursor: "pointer",
                      // padding: "5px",
                    }}
                    type="button"
                    onClick={deleteList}
                    disabled={state.list.length < 2}
                  >
                    Delete
                  </Button>
                  <Button
                  
                    type="button"
                    onClick={addListItems}
                    disabled={state.list.length === 8}
                  >
                    Add
                  </Button>
                </div>
      <div
        style={{
          fontSize: "7px",
          textAlign: "right",
        }}
        className="footer"
      ></div>

      <Handle
        type="target"
        position={Position.Top}
        id="d"
        style={{
          background: "#ADADAD",
          width: "6px",
          height: "6px",
          borderRadius: "60%",
          left: 10,
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          position: "absolute",
          bottom: 10,
          right: 10,
        }}
      >
        <Handle
          type="source"
          position={Position.Bottom}
          id="e"
          style={handleStyle}
          isConnectable={isConnectable}
        />
      </div>
    </div>
  );
}

export default CustomNode3;
